/* ══════════════════════════════════════════════════════════════════════
   assets/uc-cart-upgrade.js
   URBAN Care — Sepette set yükseltme

   Tıklanınca:
     1. Sepeti taze okur (kart çizildikten sonra sepet değişmiş olabilir)
     2. data-plan'daki ürünleri (ürünId:adet) sepetteki satırlardan düşer
     3. Seti `_cart_upgrade` gizli özelliğiyle ekler
     4. Eski satırları azaltır + "Sepet Yükseltme" notunu günceller
     5. Hata olursa eklenen seti geri alır
   Ardından temanın kendi cart-items yenilemesini çağırır.
   ══════════════════════════════════════════════════════════════════════ */
if (!customElements.get('uc-cart-upgrade')) {
  class UcCartUpgrade extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.btn = this.querySelector('[data-up-btn]');
      this.err = this.querySelector('[data-up-err]');
      if (!this.btn) return;
      this.btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        this.run();
      });
    }

    static wait(ms) {
      return new Promise((resolve) => { setTimeout(resolve, ms); });
    }

    async request(url, options) {
      for (let attempt = 0; attempt < 3; attempt += 1) {
        const response = await fetch(url, {
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          ...options
        });
        if (response.status === 429) {
          await UcCartUpgrade.wait(500 * (attempt + 1));
          continue;
        }
        let data = null;
        try { data = await response.json(); } catch (e) { data = null; }
        if (!response.ok || !data || data.status) {
          throw new Error((data && (data.description || data.message)) || `HTTP ${response.status}`);
        }
        return data;
      }
      throw new Error('429');
    }

    plan() {
      return (this.dataset.plan || '')
        .split(',')
        .filter(Boolean)
        .map((part) => {
          const [pid, units] = part.split(':');
          return { pid: Number(pid), units: Number(units) || 1 };
        });
    }

    static isGift(item) {
      const p = item.properties || {};
      return p._free_gift === 'true' || p._free_gift === true;
    }

    async run() {
      if (this.busy) return;
      this.busy = true;
      this.btn.disabled = true;
      if (this.err) this.err.hidden = true;

      let addedKey = null;
      try {
        const cart = await this.request('/cart.js', { method: 'GET' });

        const updates = {};
        this.plan().forEach((step) => {
          let left = step.units;
          cart.items.forEach((item) => {
            if (left <= 0 || item.product_id !== step.pid || UcCartUpgrade.isGift(item)) return;
            const current = updates[item.key] != null ? updates[item.key] : item.quantity;
            const take = Math.min(current, left);
            if (take <= 0) return;
            updates[item.key] = current - take;
            left -= take;
          });
          if (left > 0) throw new Error('stale');
        });

        const label = this.dataset.label || '';
        const added = await this.request('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            items: [{ id: Number(this.dataset.variant), quantity: 1, properties: { _cart_upgrade: label } }]
          })
        });
        addedKey = added && added.items && added.items[0] ? added.items[0].key : null;

        const previous = (cart.attributes && cart.attributes['Sepet Yükseltme']) || '';
        const log = previous ? `${previous} | ${label}` : label;

        await this.request('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify({ updates, attributes: { 'Sepet Yükseltme': log } })
        });

        this.refreshCart();
      } catch (error) {
        if (addedKey) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: addedKey, quantity: 0 })
            });
          } catch (e) { /* geri alma denendi */ }
        }
        if (this.err) {
          this.err.hidden = false;
          this.err.dataset.code = error.message;
        }
        this.btn.disabled = false;
        this.busy = false;
        console.warn('[uc-cart-upgrade]', error); // eslint-disable-line
        if (error.message === 'stale') this.refreshCart();
      }
    }

    refreshCart() {
      const cartItems = this.closest('cart-items') || document.querySelector('cart-items');
      if (cartItems && typeof cartItems.refresh === 'function') {
        cartItems.refresh();
      } else if (document.getElementById('cart-drawer')) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      } else {
        window.location.reload();
      }
    }
  }

  customElements.define('uc-cart-upgrade', UcCartUpgrade);
}
